import { userRequest, BASE_URL } from "../requestMethods";
import { toast } from "react-toastify";

export const applyCoupon = async (obj) => {
  try {
    console.log(" am here ", obj);
    return await userRequest.post(`${BASE_URL}coupons/applyCoupon`, obj);
    // if (res?.data?.status === true) {
    //   toast.success(`🦄 ${res.data.message}`);
    // }
    // return res.data;
  } catch (error) {
    toast.error(`🦄 ${error?.response?.data?.err}`);
    console.log("err at coupon apply", error);
  }
};
